import {
  IconMapHighway16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroMsk16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroSpb16,
  IconMapTrain16,
  IconMapWalk16,
  type ISVGIconProps,
} from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import styles from './TransportIcon.css';
import { TransportTypes } from './types';

type TransportIconProps = {
  iconType: TransportTypes;
  iconColor: string;
};

export const TransportIcon: FC<TransportIconProps> = props => {
  const { iconType, iconColor } = props;

  const Icon = ((): FC<ISVGIconProps> => {
    switch (iconType) {
      case 'spb':
        return IconMapMetroSpb16;
      case 'ekb':
        return IconMapMetroEkb16;
      case 'kzn':
        return IconMapMetroKzn16;
      case 'nsk':
        return IconMapMetroNovosib16;
      case 'smr':
        return IconMapMetroSam16;
      case 'nn':
        return IconMapMetroNN16;
      case 'mow':
        return IconMapMetroMsk16;
      case 'highway':
        return IconMapHighway16;
      case 'railway':
        return IconMapTrain16;
      case 'walk':
        return IconMapWalk16;
    }
  })();

  return (
    <div className={styles['container']} style={{ color: iconColor }}>
      <Icon color="current_color" />
    </div>
  );
};
